module.exports = __webpack_public_path__ + "static/media/YS_halo.3b91d49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_halo.png
// module id = 49
// module chunks = 0